import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { type IDropdownItem, InputCheckbox } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { makeTextFieldClear } from 'shared/ui/TextField'
import { TextFieldWithLabel } from 'shared/ui/TextFieldWithLabel/TextFieldWithLabel'
import { FieldTypeConfig } from 'entities/CustomField/lib/fieldTypeConfig'
import { type CustomFieldModalStore } from 'entities/CustomField/ui/CustomFieldModal/store/CustomFieldModalStore'

import styles from './styles.module.scss'

type ICustomFieldModalContentProps = {
  store: CustomFieldModalStore
}

export const CustomFieldModalContent = observer(({ store }: ICustomFieldModalContentProps) => {
  const {
    name,
    fieldType,
    visible,
    toggleVisible,
    setName,
    setFieldTypeFromDropdown,
    nameError,
    typeError,
  } = store

  const dropdownItems: IDropdownItem[] = useMemo(
    () =>
      [...Object.entries(FieldTypeConfig)].map(([type, data]) => ({
        label: data.label,
        iconL: data.icon,
        id: type,
      })),
    []
  )

  return (
    <div className={styles.container}>
      <TextFieldWithLabel
        labelProps={{ label: { text: 'Name' } }}
        textFieldProps={{
          value: name,
          onChange: setName,
          InputProps: { placeholder: 'Enter name' },
        }}
        rightActions={[makeTextFieldClear()]}
        errorMessage={nameError ?? undefined}
        limit={255}
      />

      <SelectField
        labelText='Type'
        items={dropdownItems}
        value={fieldType ?? undefined}
        setValue={setFieldTypeFromDropdown}
        error={typeError ?? undefined}
        size='medium'
        btnProps={{
          text: fieldType ? FieldTypeConfig[fieldType].label : 'Select',
          textIcon: fieldType ? FieldTypeConfig[fieldType].icon : undefined,
          textIconColor: 'var(--content-primary-tertiary)',
          className: typeError ? styles.selectError : undefined,
        }}
      />

      <InputCheckbox
        checked={visible}
        onChecked={toggleVisible}
        label='Show in conversations'
        color='var(--content-primary-tertiary)'
      />
    </div>
  )
})
